import { Info } from '@mui/icons-material'
import { Box } from '@mui/material'
import { RequestType } from '../../models'
import { CustomWidthTooltip } from '../../shared/UI/CustomToolTip/CustomTooltip'
import { callOutFromContent } from '../../utils/constants'

export type ToolTipProps = {
  type: RequestType
  isManager?: boolean
  useShifts?: boolean
}

export const getPaidOrTotalString = ({ type, useShifts }: ToolTipProps): string => {
  const isOnCall = type === RequestType.ON_CALL || type === RequestType.ON_CALL_M
  if (isOnCall && useShifts) return 'Shifts'
  return isOnCall ? 'Paid Hours' : 'Total Hours'
}

export const renderOnCallTooltip = ({
  type,
  isManager,
  useShifts,
}: ToolTipProps): JSX.Element | null => {
  if ((type === RequestType.ON_CALL || type === RequestType.ON_CALL_M) && !isManager) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 0.6, flexGrow: 1 }}>
        <CustomWidthTooltip
          title={
            useShifts
              ? callOutFromContent.onCallShiftsTooltip
              : callOutFromContent.onCallHoursTooltip
          }
          data-testid="TotalOrPaid-hours-tooltip"
        >
          <Info fontSize="small" sx={{ color: '#20C5A0', marginLeft: '4px' }} />
        </CustomWidthTooltip>
      </Box>
    )
  }
  return null
}
